import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getApiUrl } from '../../utils/api';

export const COMPARAISON_EVENT = 'comparaison-changed';
export const MODES = [
  ['precedente', 'Période précédente', 'J-1 · S-1 · M-1 · T-1 : la période juste avant, sur la même année'],
  ['n1', 'L’an dernier', 'Même jour de semaine il y a 52 semaines, même semaine, même mois, même trimestre de l’an dernier'],
];

// Période de référence des comparaisons (réglage établissement) — partagé Paramètres ↔ barre de période Finance
export const useComparaison = () => {
  const [mode, setMode] = useState(null);
  const [saving, setSaving] = useState(false);
  const load = useCallback(() => axios.get(`${getApiUrl()}/finance/comparaison`, { withCredentials: true }).then((r) => setMode(r.data.comparaison)).catch(() => setMode('precedente')), []);
  useEffect(() => { load(); window.addEventListener(COMPARAISON_EVENT, load); return () => window.removeEventListener(COMPARAISON_EVENT, load); }, [load]);
  const save = async (next) => {
    if (next === mode || saving) return;
    setSaving(true);
    try {
      const r = await axios.put(`${getApiUrl()}/finance/comparaison`, { comparaison: next }, { withCredentials: true });
      setMode(r.data.comparaison);
      window.dispatchEvent(new Event(COMPARAISON_EVENT));
      toast.success(next === 'n1' ? 'Comparaisons calculées vs la même période l’an dernier (N-1)' : 'Comparaisons calculées vs la période précédente');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Réglage non enregistré');
    } finally { setSaving(false); }
  };
  return { mode, saving, save };
};
